export const ROLE_CATEGORY_CONSTANT = Object.freeze({
    SUPER_ADMIN: "super_admin",
    NEXSOFT: "nexsoft",
    DISTRIBUTOR: "distributor",
    PRINCIPAL: "principal",
    CSO: "cso",
});